<template>
    <label class="text-xs font-bold"><slot></slot></label>
</template>